<section class="container py-5 mt-5 mb-2 mb-sm-3 mb-lg-4 mb-xxl-5">
  <h1 class="display-4 pb-3 pb-md-4 pb-lg-5">Cum functioneaza</h1>

  <div class="row align-items-center pt-xl-2 mb-lg-2 mb-xl-3 mb-xxl-4">
    <div class="col-md-7 col-lg-6 mb-4 mb-md-0">
      <div class="d-block position-relative">
        <div class="bg-faded-primary rounded-5 position-absolute top-0 start-0 w-100 h-100" data-aos="zoom-in"
          data-aos-duration="600" data-aos-offset="250"></div>

        <svg-icon src="assets/images/illustrations/gift-card.svg" class="d-block position-relative zindex-2 ms-auto p-3"
          data-aos="fade-in" data-aos-duration="400" data-aos-offset="250"></svg-icon>

      </div>
    </div>
    <div class="col-md-5 col-xl-4 offset-lg-1" data-aos="fade-up" data-aos-duration="400" data-aos-offset="170">
      <div class="ps-md-3 ps-lg-0">
        <h2 class="h1 pb-md-2 pb-xl-3">Vreau sa ofer un cadou</h2>
        <p class="pb-3 mb-3 mb-lg-4">
          Acum este foarte simplu sa oferi cadoul perfect! Daruind <span class="text-primary fw-bold">Cardul Cadou
            GiftShare</span> oferi posibilitatea
          sarbatoritului sa isi aleaga exact ce isi doreste de la cele peste {{(systemStatistics$ |
          async)?.voucherNonCharityCount}} magazine partenere GiftShare.
        </p>
        <a [routerLink]="['/carduri-cadou']" class="btn btn-lg btn-primary rounded-pill">Cumpara un card cadou</a>
      </div>
    </div>
  </div>
</section>

<!-- How it works (Steps)-->
<section class="overflow-hidden py-5 my-md-2 my-xl-4 my-xxl-5 bg-secondary">
  <div class="container py-2 py-sm-4 py-lg-5">
    <h2 class="h1 text-center pb-3 mb-3 mb-lg-4 mt-xxl-2">Cum faci un cadou de grup?</h2>
    <!-- Step-->
    <div class="row align-items-center position-relative pb-5 pb-lg-0 mb-1 mb-sm-2 mb-md-4 mb-lg-0">
      <div class="col-md-6 col-xl-5 offset-lg-1 order-md-2 d-md-flex justify-content-end pb-2 pb-md-0 mb-4 mb-md-0"
        data-aos="fade-left" data-aos-duration="500" data-aos-offset="250" data-disable-parallax-down="md">
        <svg-icon src="/assets/images/illustrations/how-it-works-01.svg" [svgStyle]="{'height.px': 370}"></svg-icon>
      </div>
      <div class="col-md-6 col-lg-5 col-xl-4 offset-xl-1 order-md-1" data-aos="fade-right" data-aos-duration="500"
        data-aos-offset="250" data-disable-parallax-down="md">
        <div class="pe-md-4 pe-lg-0"><span class="badge fs-sm bg-faded-primary text-primary mb-3 mb-lg-4">Pasul
            1</span>
          <h3 class="h2 mb-3 mb-lg-4">Creeaza un eveniment, simplu si rapid</h3>
          <p class="pb-1 pb-lg-0 mb-4 mb-lg-5">Pe GiftShare creezi un eveniment in doar cateva minute. Este pagina in
            care spui colegilor si prietenilor despre evenimentul sarbatorit, fie ca este vorba despre aniversarea
            cuiva, o petrecere de casa noua, o cununie sau poate chiar un baby shower sau botez. Poti personaliza
            evenimentul cu o poza amuzanta 😄</p>
          <a [routerLink]="['/user/creare-eveniment']" class="btn btn-outline-primary rounded-pill">Creeaza
            eveniment</a>
        </div>
      </div>
    </div>
    <!-- Arrow-->
    <div class="d-none d-lg-flex justify-content-center" data-aos="fade-in" data-aos-duration="500"
      data-aos-offset="250">
      <svg class="d-block text-primary" width="339" height="365" viewBox="0 0 339 365" fill="none"
        xmlns="http://www.w3.org/2000/svg" style="margin-left: -150px; margin-top: -140px; margin-bottom: -108px;">
        <path d="M324 291.371C120.111 291.37 240.756 58.7225 1.00032 73.2606" stroke="url(#arrow1)" stroke-width="2"
          stroke-linecap="round" stroke-dasharray="6 6"></path>
        <path
          d="M337.375 290.62C338.074 290.998 338.074 292.001 337.375 292.379L328.476 297.196C327.81 297.557 327 297.074 327 296.317L327 286.683C327 285.925 327.81 285.443 328.476 285.803L337.375 290.62Z"
          fill="currentColor"></path>
        <defs>
          <linearGradient id="arrow1" x1="324" y1="291.5" x2="-2.99974" y2="72.4997" gradientUnits="userSpaceOnUse">
            <stop offset="0" stop-color="currentColor"></stop>
            <stop offset="1" stop-color="currentColor" stop-opacity="0"></stop>
          </linearGradient>
        </defs>
      </svg>
    </div>
    <!-- Step-->
    <div class="row align-items-center position-relative pb-5 pb-lg-0 mb-1 mb-sm-2 mb-md-4 mb-lg-0">
      <div class="col-md-6 col-xl-5 offset-xl-1 pb-2 pb-md-0 mb-4 mb-md-0" data-aos="fade-right" data-aos-duration="500"
        data-aos-offset="250" data-disable-parallax-down="md">
        <svg-icon src="/assets/images/illustrations/how-it-works-02.svg" [svgStyle]="{'height.px': 370}"></svg-icon>
      </div>
      <div class="col-md-6 col-lg-5 col-xl-4 offset-lg-1" data-aos="fade-left" data-aos-duration="500"
        data-aos-offset="250" data-disable-parallax-down="md">
        <div class="ps-md-4 ps-lg-0"><span class="badge fs-sm bg-faded-primary text-primary mb-3 mb-lg-4">Pasul
            2</span>
          <h3 class="h2 mb-3 mb-lg-4">Invita & distribuie</h3>
          <p class="pb-1 pb-lg-0 mb-4 mb-lg-5">Odata creat evenimentul, vei primi pe e-mail o confirmare ca acesta este
            activ. Acum poti incepe sa dai sfoara in tara, transmite link-ul evenimentului colegilor si prietenilor prin
            mijloacele electronice puse la dispozitia ta: Email, Facebook, Messenger, WhatsApp, etc.</p>
        </div>
      </div>
    </div>
    <!-- Arrow-->
    <div class="d-none d-lg-flex justify-content-center" data-aos="fade-in" data-aos-duration="500"
      data-aos-offset="250">
      <svg class="d-block text-primary" width="263" height="275" viewBox="0 0 263 275" fill="none"
        xmlns="http://www.w3.org/2000/svg" style="margin-top: -60px; margin-left: -120px; margin-bottom: -80px;">
        <path
          d="M8.13678 249.647C7.47108 250.081 6.59001 249.602 6.59106 248.808L6.60444 238.689C6.60544 237.931 7.4158 237.45 8.08162 237.811L16.5478 242.408C17.2136 242.77 17.2512 243.712 16.6163 244.125L8.13678 249.647Z"
          fill="currentColor"></path>
        <path
          d="M261.961 37.8891C216.908 65.6243 128.226 135.486 133.916 193.05C141.029 265.005 265.134 173.468 173.666 148.634C89.2542 125.715 30.9125 210.547 13.9796 236.702"
          stroke="url(#arrow2)" stroke-width="2" stroke-linecap="round" stroke-dasharray="6 6"></path>
        <defs>
          <linearGradient id="arrow2" x1="13.9797" y1="234.5" x2="276.704" y2="60.1939" gradientUnits="userSpaceOnUse">
            <stop offset="0" stop-color="currentColor"></stop>
            <stop offset="1" stop-color="currentColor" stop-opacity="0"></stop>
          </linearGradient>
        </defs>
      </svg>
    </div>
    <!-- Step-->
    <div class="row align-items-center position-relative pb-5 pb-lg-0 mb-1 mb-sm-2 mb-md-4 mb-lg-0">
      <div class="col-md-6 col-xl-5 offset-lg-1 order-md-2 d-md-flex justify-content-end pb-2 pb-md-0 mb-4 mb-md-0"
        data-aos="fade-left" data-aos-duration="500" data-aos-offset="250" data-disable-parallax-down="md">
        <svg-icon src="/assets/images/illustrations/how-it-works-03.svg" [svgStyle]="{'height.px': 370}"></svg-icon>
      </div>
      <div class="col-md-6 col-lg-5 col-xl-4 offset-xl-1 order-md-1" data-aos="fade-right" data-aos-duration="500"
        data-aos-offset="250" data-disable-parallax-down="md">
        <div class="pe-md-4 pe-lg-0"><span class="badge fs-sm bg-faded-primary text-primary mb-3 mb-lg-4">Pasul
            3</span>
          <h3 class="h2 mb-3 mb-lg-4">Colectezi fondurile</h3>
          <p class="pb-1 pb-lg-0 mb-4 mb-lg-5">Prietenii vor putea sa contribuie la cadoul de grup, sigur si rapid,
            printr-o plata securizata cu cardul.</p>
        </div>
      </div>
    </div>
    <!-- Arrow-->
    <div class="d-none d-lg-flex justify-content-center" data-aos="fade-in" data-aos-duration="500"
      data-aos-offset="250">
      <svg class="d-block text-primary" width="339" height="365" viewBox="0 0 339 365" fill="none"
        xmlns="http://www.w3.org/2000/svg" style="margin-left: -150px; margin-top: -140px; margin-bottom: -108px;">
        <path d="M324 291.371C120.111 291.37 240.756 58.7225 1.00032 73.2606" stroke="url(#arrow1)" stroke-width="2"
          stroke-linecap="round" stroke-dasharray="6 6"></path>
        <path
          d="M337.375 290.62C338.074 290.998 338.074 292.001 337.375 292.379L328.476 297.196C327.81 297.557 327 297.074 327 296.317L327 286.683C327 285.925 327.81 285.443 328.476 285.803L337.375 290.62Z"
          fill="currentColor"></path>
        <defs>
          <linearGradient id="arrow1" x1="324" y1="291.5" x2="-2.99974" y2="72.4997" gradientUnits="userSpaceOnUse">
            <stop offset="0" stop-color="currentColor"></stop>
            <stop offset="1" stop-color="currentColor" stop-opacity="0"></stop>
          </linearGradient>
        </defs>
      </svg>
    </div>
    <!-- Step-->
    <div class="row align-items-center position-relative">
      <div class="col-md-6 col-xl-5 offset-xl-1 pb-2 pb-md-0 mb-4 mb-md-0" data-aos="fade-right" data-aos-duration="500"
        data-aos-offset="250" data-disable-parallax-down="md">
        <svg-icon src="/assets/images/illustrations/how-it-works-04.svg" [svgStyle]="{'height.px': 370}"></svg-icon>
      </div>
      <div class="col-md-6 col-lg-5 col-xl-4 offset-lg-1" data-aos="fade-left" data-aos-duration="500"
        data-aos-offset="250" data-disable-parallax-down="md">
        <div class="ps-md-4 ps-lg-0"><span class="badge fs-sm bg-faded-primary text-primary mb-3 mb-lg-4">Pasul
            4</span>
          <h3 class="h2 mb-3 mb-lg-4">Alegerea cadoului perfect</h3>
          <p class="pb-1 pb-lg-0 mb-4 mb-lg-5">Acum vine partea cea mai frumoasa: alegerea cadoului mult dorit! In cazul
            in care ai creat un eveniment pentru un prieten, acesta va primi un email de instiintare despre cadoul
            vostru de grup. Tot ce ramane de facut este ca el sa isi aleaga cadoul perfect de la unul sau mai multi
            parteneri GiftShare, sau chiar sa sustina o cauza sociala prin donarea catre un ONG.</p>
        </div>
      </div>
    </div>
  </div>
</section>


<!-- CTA-->
<section class="mb-md-2 mb-xl-4 mb-xxl-5">
  <div class="container">
    <div class="bg-info rounded-5 position-relative overflow-hidden py-5 px-4 px-sm-5">
      <div class="d-none d-dark-mode-block position-absolute top-0 start-0 w-100 h-100"
        style="background-color: rgba(255,255,255, .02);"></div>
      <svg class="position-absolute start-0 bottom-0 zindex-2" width="713" height="410" viewBox="0 0 713 410"
        fill="none" stroke="white" stroke-opacity="0.12" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M682.907 484.533C695.503 444.57 705.228 400.872 691.238 361.386C672.894 309.65 617.745 278.967 563.532 270.375C509.32 261.768 454.065 270.505 399.207 272.603C344.348 274.702 285.906 268.882 241.992 235.917C181.111 190.21 163.777 104.969 109.285 51.7863C63.8512 7.45308 -6.63234 -9.27787 -67.1491 9.9424">
        </path>
        <path
          d="M641.482 482.967C653.4 445.169 662.6 403.82 649.367 366.472C632.013 317.53 579.846 288.506 528.564 280.379C477.267 272.236 425.011 280.507 373.121 282.492C321.231 284.477 265.935 278.97 224.403 247.786C166.796 204.54 150.415 123.91 98.8593 73.6098C55.8807 31.6733 -10.8023 15.8433 -68.0415 34.0275">
        </path>
        <path
          d="M600.052 481.4C611.277 445.751 619.968 406.784 607.477 371.559C591.113 325.409 541.928 298.044 493.561 290.383C445.194 282.705 395.92 290.508 346.984 292.363C298.047 294.234 245.913 289.041 206.762 259.639C152.445 218.868 137.002 142.834 88.3989 95.4004C47.876 55.8447 -14.9912 40.9323 -68.9688 58.0798">
        </path>
        <path
          d="M558.622 479.833C569.168 446.349 577.336 409.73 565.601 376.644C550.227 333.287 504.025 307.582 458.589 300.385C413.153 293.173 366.862 300.493 320.893 302.251C274.925 304.009 225.953 299.128 189.168 271.507C138.142 233.198 123.636 161.774 77.9686 117.223C39.9006 80.0639 -19.166 66.0526 -69.8661 82.164">
        </path>
        <path
          d="M517.195 478.267C527.064 446.932 534.691 412.678 523.729 381.732C509.361 341.167 466.125 317.121 423.62 310.39C381.115 303.643 337.806 310.496 294.806 312.141C251.807 313.785 205.981 309.216 171.561 283.377C123.825 247.544 110.24 180.715 67.5263 139.03C31.9133 104.268 -23.3529 91.1578 -70.7753 106.233">
        </path>
      </svg>
      <svg class="position-absolute top-0 end-0 zindex-2" width="317" height="367" viewBox="0 0 317 367" fill="none"
        stroke="white" stroke-opacity="0.12" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M766.907 366.533C779.503 326.57 789.228 282.872 775.238 243.386C756.894 191.65 701.745 160.967 647.532 152.375C593.32 143.768 538.065 152.505 483.207 154.603C428.348 156.702 369.906 150.882 325.992 117.917C265.111 72.2101 247.777 -13.031 193.285 -66.2137C147.851 -110.547 77.3677 -127.278 16.8509 -108.058">
        </path>
        <path
          d="M725.482 364.967C737.4 327.169 746.6 285.82 733.367 248.472C716.013 199.53 663.846 170.506 612.564 162.379C561.267 154.236 509.011 162.507 457.121 164.492C405.231 166.477 349.935 160.97 308.403 129.786C250.796 86.5396 234.415 5.91023 182.859 -44.3902C139.881 -86.3267 73.1977 -102.157 15.9585 -83.9725">
        </path>
        <path
          d="M684.052 363.4C695.277 327.751 703.968 288.784 691.477 253.559C675.113 207.409 625.928 180.044 577.561 172.383C529.194 164.705 479.92 172.508 430.984 174.363C382.047 176.234 329.913 171.041 290.762 141.639C236.445 100.868 221.002 24.8341 172.399 -22.5996C131.876 -62.1553 69.0088 -77.0677 15.0312 -59.9202">
        </path>
        <path
          d="M642.622 361.833C653.168 328.349 661.336 291.73 649.601 258.644C634.227 215.287 588.025 189.582 542.589 182.385C497.153 175.173 450.862 182.493 404.893 184.251C358.925 186.009 309.953 181.128 273.168 153.507C222.142 115.198 207.636 43.7743 161.969 -0.777178C123.901 -37.9361 64.834 -51.9474 14.1339 -35.836">
        </path>
        <path
          d="M601.195 360.267C611.064 328.932 618.691 294.678 607.729 263.732C593.361 223.167 550.125 199.121 507.62 192.39C465.115 185.643 421.806 192.496 378.806 194.141C335.807 195.785 289.981 191.216 255.561 165.377C207.825 129.544 194.24 62.7152 151.526 21.0304C115.913 -13.7317 60.6471 -26.8422 13.2247 -11.7668">
        </path>
      </svg>
      <div class="dark-mode position-relative zindex-3 text-center px-3 px-sm-0 pb-2 py-sm-3 py-md-4 py-lg-5">
        <h2 class="display-3 pt-xl-2">Cadoul Perfect De Fiecare Data</h2>
        <!-- <p class="fs-lg pb-4 pb-lg-5 mb-2 mb-sm-3 mb-lg-0 mb-xl-2">Using basic data skills you can analysis and improve your business indicators.</p> -->
        <a [routerLink]="['/user/creare-eveniment']" class="btn btn-lg btn-light rounded-pill mb-lg-2 mb-xl-4">Creeaza
          eveniment</a>
      </div>
    </div>
  </div>
</section>

<!-- How it works steps-->
<section class="overflow-hidden bg-secondary">
  <section class="container pb-5 pt-3 pt-md-4 pt-lg-5 my-xl-3 my-xxl-5">
    <h2 class="h1 text-center pb-3 mb-3 mb-lg-4 mt-xxl-2">Am primit un cadou prin GiftShare</h2>
    <div class="row pb-md-3 pb-lg-4 mb-2 mb-lg-3">
      <div class="col-md-5 d-flex flex-column align-items-center mb-4 mb-md-0">
        <div class="position-relative" style="max-width: 416px;">
          <svg-icon src="/assets/images/illustrations/card-giftshare.svg" [svgStyle]="{'width.px': 450}"></svg-icon>
        </div>
        <div class="text-center text-md-start pt-3 mt-3">
          <p class="fs-xl mb-0">Daca ai primit din partea prietenilor un cadou de grup sau
            un card cadou GiftShare, este foarte simplu sa-ti alegi cadoul perfect!</p>
        </div>
      </div>
      <!-- Steps-->
      <div class="col-md-7 col-lg-6 col-xxl-5 offset-lg-1 offset-xxl-2">
        <div class="ps-md-4 ps-lg-0">
          <div class="position-relative d-flex justify-content-end my-3 py-1" data-aos="fade-left"
            data-aos-easing="ease-out-back">
            <div
              class="btn btn-lg btn-icon btn-primary fs-xl fw-bold rounded-circle position-absolute top-50 start-0 translate-middle-y zindex-2 pe-none">
              1</div>
            <div class="card border-0 ps-3" style="width: calc(100% - 1.75rem);">
              <div class="card-body ps-4">
                <h3 class="h5 card-title pb-2 mb-1">Cont GiftShare</h3>
                <p class="card-text">Creeaza-ti un cont GiftShare sau autentifica-te, daca detii deja unul</p>
              </div>
            </div>
          </div>
          <div class="position-relative d-flex justify-content-end my-3 py-1" data-aos="fade-left"
            data-aos-easing="ease-out-back" data-aos-delay="250">
            <div
              class="btn btn-lg btn-icon btn-primary fs-xl fw-bold rounded-circle position-absolute top-50 start-0 translate-middle-y zindex-2 pe-none">
              2</div>
            <div class="card border-0 ps-3" style="width: calc(100% - 1.75rem);">
              <div class="card-body ps-4">
                <h3 class="h5 card-title pb-2 mb-1">Aplica un card</h3>
                <p class="card-text">Introduci codul cardului cadou in meniul "Aplica un card GiftShare" si balanta ta
                  GiftShare va fi actualizata</p>
              </div>
            </div>
          </div>
          <div class="position-relative d-flex justify-content-end my-3 py-1" data-aos="fade-left"
            data-aos-easing="ease-out-back" data-aos-delay="500">
            <div
              class="btn btn-lg btn-icon btn-primary fs-xl fw-bold rounded-circle position-absolute top-50 start-0 translate-middle-y zindex-2 pe-none">
              3</div>
            <div class="card border-0 ps-3" style="width: calc(100% - 1.75rem);">
              <div class="card-body ps-4">
                <h3 class="h5 card-title pb-2 mb-1">Carduri parteneri</h3>
                <p class="card-text">Iti alegi cadoul perfect de la peste {{(systemStatistics$ |
                  async)?.voucherNonCharityCount}} magazine partenere GiftShare prin
                  comandarea unuia sau mai multor carduri cadou la parteneri, acestea fiind folosite la achitarea
                  partiala sau totala a produselor alese de la respectivii parteneri.</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</section>

<section class="container py-5 my-2 my-lg-3 my-xl-4 my-xxl-5 text-center">
  <h2 class="h1">Tipuri de evenimente</h2>
  <p class="pb-1 pb-sm-2 pb-md-3 pb-lg-4 mb-3">Cateva exemple de evenimente pentru care poti folosi GiftShare pentru a
    face un cadou</p>
  <div class="row row-cols-2 row-cols-md-3 row-cols-xl-4 g-2 g-md-4">
    <div class="col">
      <a [routerLink]="['/user/creare-eveniment']" [queryParams]="{eventTypeId: 42}"
        class="card-hover card-lifted d-inline-block text-decoration-none"><img
          class="card-lifted d-block rounded-5 mb-3" src="/assets/images/event-types/aniversare.jpg" alt="Aniversare">
        <h3 class="h5 mb-1">Aniversare</h3>
      </a>
    </div>

    <div class="col">
      <a [routerLink]="['/user/creare-eveniment']" [queryParams]="{eventTypeId: 80}"
        class="card-hover card-lifted d-inline-block text-decoration-none"><img
          class="card-lifted d-block rounded-5 mb-3" src="/assets/images/event-types/caritate.jpg" alt="Caritate">
        <h3 class="h5 mb-1">Caritate</h3>
      </a>
    </div>

    <div class="col">
      <a [routerLink]="['/user/creare-eveniment']" [queryParams]="{eventTypeId: 41}"
        class="card-hover card-lifted d-inline-block text-decoration-none"><img
          class="card-lifted d-block rounded-5 mb-3" src="/assets/images/event-types/casa-noua.jpg" alt="Casa noua">
        <h3 class="h5 mb-1">Casa noua</h3>
      </a>
    </div>

    <div class="col">
      <a [routerLink]="['/user/creare-eveniment']" [queryParams]="{eventTypeId: 20}"
        class="card-hover card-lifted d-inline-block text-decoration-none"><img
          class="card-lifted d-block rounded-5 mb-3" src="/assets/images/event-types/casatorie.jpg" alt="Casatorie">
        <h3 class="h5 mb-1">Casatorie</h3>
      </a>
    </div>

    <div class="col">
      <a [routerLink]="['/user/creare-eveniment']" [queryParams]="{eventTypeId: 64}"
        class="card-hover card-lifted d-inline-block text-decoration-none"><img
          class="card-lifted d-block rounded-5 mb-3" src="/assets/images/event-types/nou-nascut.jpg" alt="Nou nascut">
        <h3 class="h5 mb-1">Nou nascut</h3>
      </a>
    </div>

    <div class="col">
      <a [routerLink]="['/user/creare-eveniment']" [queryParams]="{eventTypeId: 56}"
        class="card-hover card-lifted d-inline-block text-decoration-none"><img
          class="card-lifted d-block rounded-5 mb-3" src="/assets/images/event-types/vacanta.jpg" alt="Vacanta">
        <h3 class="h5 mb-1">Vacanta</h3>
      </a>
    </div>

    <div class="col">
      <a [routerLink]="['/user/creare-eveniment']" [queryParams]="{eventTypeId: 89}"
        class="card-hover card-lifted d-inline-block text-decoration-none"><img
          class="card-lifted d-block rounded-5 mb-3" src="/assets/images/event-types/1-martie.jpg" alt="1 Martie">
        <h3 class="h5 mb-1">1 Martie</h3>
      </a>
    </div>

    <div class="col">
      <a [routerLink]="['/user/creare-eveniment']" [queryParams]="{eventTypeId: 81}"
        class="card-hover card-lifted d-inline-block text-decoration-none"><img
          class="card-lifted d-block rounded-5 mb-3" src="/assets/images/event-types/alte-evenimente.jpg"
          alt="Alte evenimente">
        <h3 class="h5 mb-1">Alte evenimente</h3>
      </a>
    </div>

  </div>

</section>
